/**
 * Fee calculator utility for Konzo Marketplace
 * Handles platform fee calculations and provides transaction breakdowns
 */

// Platform fee percentage (5%)
export const PLATFORM_FEE_PERCENTAGE = 5;

/**
 * Calculate the platform fee amount from a gross transaction amount
 * @param {number} amount - The gross transaction amount
 * @returns {number} - The platform fee amount
 */
export function calculatePlatformFee(amount) {
  const fee = (Number(amount) * PLATFORM_FEE_PERCENTAGE) / 100;
  return Math.round(fee); // Round to nearest integer (for UGX)
}

/**
 * Calculate the artist payout amount after deducting platform fee
 * @param {number} amount - The gross transaction amount
 * @returns {number} - The net payout amount for the artist
 */
export function calculatePayoutAmount(amount) {
  const fee = calculatePlatformFee(amount);
  return Math.round(Number(amount) - fee); // Round to nearest integer (for UGX)
}

/**
 * Get a detailed breakdown of a transaction
 * @param {number} amount - The gross transaction amount
 * @returns {Object} - Transaction breakdown with gross, fee, and net amounts
 */
export function getTransactionBreakdown(amount) {
  const grossAmount = Number(amount);
  const feeAmount = calculatePlatformFee(grossAmount);
  const netAmount = grossAmount - feeAmount;
  
  return {
    gross: Math.round(grossAmount),
    fee: Math.round(feeAmount),
    net: Math.round(netAmount),
    feePercentage: PLATFORM_FEE_PERCENTAGE
  };
}

/**
 * Format an amount as UGX currency
 * @param {number} amount - The amount to format
 * @returns {string} - Formatted amount string
 */
export function formatUGX(amount) {
  return Number(amount).toLocaleString('en-UG') + ' UGX';
}
